var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowSide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.00002 9.00003L12.17 9.00003L7.29002 13.88C6.90002 14.27 6.90002 14.91 7.29002 15.3C7.68002 15.69 8.31002 15.69 8.70002 15.3L15.29 8.71003C15.68 8.32003 15.68 7.69003 15.29 7.30003L8.70002 0.710029C8.31002 0.320028 7.68002 0.320028 7.29002 0.710029C6.90002 1.10003 6.90002 1.73003 7.29002 2.12003L12.17 7.00003L1.00002 7.00003C0.45002 7.00003 2.00272e-05 7.45003 2.00272e-05 8.00003C2.00272e-05 8.55003 0.45002 9.00003 1.00002 9.00003Z",
    fill: "#040C1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSide);
export default __webpack_public_path__ + "static/media/ArrowSide.a727e726d7fa8dcd3726a516f086e34f.svg";
export { ForwardRef as ReactComponent };